import { useMemo } from 'react';

import { MedicalImaging } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalInformationModal } from '../../MedicalInformationModal/MedicalInformationModal';

import { MedicalImagingDetails } from './MedicalImagingDetails';
import { mapMedicalImagingToMedicalInformation } from './MedicalImagingDetailsModal.utils';

type MedicalImagingDetailsModalProps = {
   readonly onClose: VoidFunction;
   readonly medicalImaging: MedicalImaging;
   readonly onMedicalDataAccessAuthorizationUpdate?: VoidFunction;
};

export const MedicalImagingDetailsModal = (props: MedicalImagingDetailsModalProps): JSX.Element => {
   const medicalInformation = useMemo(() => mapMedicalImagingToMedicalInformation(props.medicalImaging), [
      props.medicalImaging,
   ]);

   return (
      <MedicalInformationModal
         medicalInformation={medicalInformation}
         onClose={props.onClose}
         onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
      >
         <MedicalImagingDetails medicalImaging={props.medicalImaging} />
      </MedicalInformationModal>
   );
};
